import { translate } from "../../../Services/translation";

export const FilterLabelTranslations = {
  brand: translate("algolia.filters.brand.title"),
  filterSizesClothing: translate("algolia.filters.sizes-clothing.title"),
  filterSizesShoe: translate("algolia.filters.sizes-shoe.title"),
  filterSizesTrouser: translate("algolia.filters.sizes-trouser.title"),
  filterColor: translate("algolia.filters.color.title"),
  "categories.lvl0": translate("algolia.filters.category.title"),
};
